//// https://dev.to/vicnovais/creating-a-speech-synthesizer-using-web-speech-api-and-react-4iii#:~:text=First%2C%20we%20create%20a%20SpeechSynthesisUtterance,Our%20synthesizer%20is%20ready.
//// https://developer.mozilla.org/en-US/docs/Web/API/Web_Speech_API/Using_the_Web_Speech_API
//// https://developer.mozilla.org/en-US/docs/Web/API/SpeechSynthesis

import React, { useState, useEffect, Fragment } from 'react';
import { useTranslation } from "react-i18next";

import { marks } from '../../../utils/marks';
import './SpeechToTextLongTime.css';

const TextToSpeech = (props) => {
  const { responseText } = props;

  const [t] = useTranslation("translation");

  const [text, setText] = useState('');
  const [showCopied, setShowCopied] = useState(false);

  let detectedLanguage = navigator.languages[0];
  const lsUserSelectLng = localStorage.getItem('userSelectLng');

  if (lsUserSelectLng) {
    detectedLanguage = lsUserSelectLng;
  }

  useEffect(() => {
    setText(responseText);
  },[responseText]);

  useEffect(() => {
    if (text) {
      handleSpeak();
    }
  },[text]);

  const handleSpeak = () => {
    // Create a new instance of SpeechSynthesisUtterance with your text
    const utterance = new SpeechSynthesisUtterance(text);
    
    // Optional: Customize voice characteristics
    utterance.pitch = 1; // 0 to 2
    utterance.rate = 1;  // 0.1 to 10
    utterance.volume = 1; // 0 to 1
    // utterance.lang = 'en-US';
    
    if (detectedLanguage) {
      utterance.lang = detectedLanguage;
    }
    // console.log('detectedLanguage', detectedLanguage)

    // Use the window.speechSynthesis to speak the text
    window.speechSynthesis.speak(utterance);
  };
  
  const copyTextHandler = (text) => {
    navigator.clipboard.writeText(text);

    setShowCopied(true);

    setTimeout(() => {
      setShowCopied(false);
    }, 3000);
  };
  
  return (
    <Fragment>
      {responseText && (
        <div className='sttLongTimeResponse'>
          <div style={{whiteSpace: "pre-wrap"}}>
            {responseText}
          </div>
          <div className='sttLongTimeResponseCopy'>
            <span
              onClick={() => {
                copyTextHandler(responseText)
              }}
            >
              {marks.copyMark}
            </span>
            {showCopied && (
              <span>
                {' '}({t("textVoiceAssistant09", "copied")})
              </span>
            )}
          </div>
          {/* {responseText && (
            <div>
              <button onClick={handleSpeak}>
                (Speak-Text)
            </button> 
            </div>
          )} */}
        </div>
      )}
    </Fragment>
  );
};

export default TextToSpeech;